import React from 'react';

const name = (group, inputName) => {
  if (group === null || group === '') {
    return inputName;
  }
  return `${group}[${inputName}]`;
};

const TextAreaInput = props => (
  <textarea
    name={name(props.groupName, props.name)}
    rows={props.rows}
    onChange={props.onChange}
    className="form-control"
    value={props.value || ''} />
);

TextAreaInput.defaultProps = {
  rows     : 3,
  groupName: 'parameters',
  name     : '',
};

export default TextAreaInput;
